<template>
    <div>
            <div class="col-12 lg-col-7 lg-pr5 lg-pt4 border-box">
              <h2 class="h1-5 bold color1 pb3 pt2 pl1 lh-1">Vielen Dank!</h2>
              <p class="p extra-light gray pl1">Wir rufen Sie wie von Ihnen gewünscht am 
                <span class="bold">{{onBoardingAppointmentDateDefault}}</span> um <span class="bold">{{onBoardingAppointmentTimeDefault}}</span> an.
              </p>
              <button class="btn std p extra-light ls-2 white mt3" @click="startOnBoarding()">Bewertung anfordern</button>
              <div class="mb4"></div>
            </div>
            <cta-support-element :appointment="appointment"/>
    </div>
</template>

<script>

import { EventBus } from "@/event-bus.js";
import CTASupportElement from './CTASupportElement.vue'

export default {
  name: 'AppointmentStep04',
  props: {
    name: String,
    event_name: String,
    button_style: String,
    appointment: Boolean,
    onBoardingAppointmentDateDefault: String,
    onBoardingAppointmentTimeDefault: String,

  },
  data() {
    return {
      notfilled: false,
      debug: false,
      dataEvents: {
        machinecategory_selected: false
      },
      isValid: false,
    }
  },
  created() {
    // EventBus.$on('submit_step_app100', () => { // Kein payload!
    //   this.log(this);
    //     this.log('OnboardingStep01 Event received: submit_step_app100');
    // });

    EventBus.$on('pre_submit_step_app200', () => {
      if(this.date != "") {
        this.notfilled = false;
          EventBus.$emit('submit_step_app200', {
           "appointment_time": this.time
          });
      } else {
        // TODO: Alertbox nothing inserted!
        this.notfilled = true;
      }
    });

  },
  components: {
    'cta-support-element': CTASupportElement
  },
  methods: {
    submit: function() {
        this.log('Appointment01.vue: Emitting Event using Submit: ' + this.event_name);
        EventBus.$emit(""+this.event_name);
    },
    log: function (obj) {
      if(this.debug) {
        this.log(obj)
      }
    },
    startOnBoarding(){
      EventBus.$emit("start_onboarding");
    }
    
    
  }
}
</script>

<style scoped>
.underlined{
  border-bottom: 1px solid #0176CD;
  cursor:pointer;
}
.h2_backwards {
color: #9395a6;
font-size: 20px;
}

@media(max-width: 769px){
  .btn{
    width: auto !important;
    margin-left: 0;
  }
  p{
    margin-left: 0;
    padding-left: 0;
  }
  h2{
    margin-left: 0;
    padding-left: 0;
  }
}
@media(max-width: 475px){
  .btn{
    font-size: .8rem;
    padding: 19px 20px;
    white-space: normal;
  }
}
</style>